import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function MirariEchoBanner() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref} className="bg-white py-0 px-8 lg:px-32">
      <div className="max-w-7xl mx-auto">
        <Link
          to="/mirari-echo"
          className={`block group cursor-pointer transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="relative w-full h-[420px] rounded-2xl overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/e1d490d1349e9b82005b82aa6a942a42.jpg"
              alt="Echo - Interactive Installation by mirari x BITMOVES"
              className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent"></div>

            <div className="absolute inset-0 flex items-center px-12 lg:px-20">
              <div className="max-w-xl">
                <div className="flex items-center gap-4 mb-5">
                  <span className="px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs uppercase tracking-wider rounded-full whitespace-nowrap">
                    Public Space
                  </span>
                  <span className="px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs uppercase tracking-wider rounded-full whitespace-nowrap">
                    Now Available in Japan
                  </span>
                </div>

                <h3 className="text-4xl lg:text-5xl font-light text-white mb-4 leading-tight">
                  Echo
                </h3>

                <p className="text-base text-white/85 leading-relaxed mb-3">
                  カナダ・モントリオールのクリエイティブスタジオ mirari
                  との協業による、マルチセンサリー・インタラクティブインスタレーション。日本国内レンタル開始。
                </p>
                <p className="text-sm text-white/60 leading-relaxed mb-8">
                  A multi-sensory interactive installation in collaboration with mirari. Now
                  available for rental in Japan.
                </p>

                <span className="inline-flex items-center gap-2 text-sm font-medium text-white group-hover:gap-4 transition-all duration-300 whitespace-nowrap">
                  詳しく見る / Learn More
                  <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center"></i>
                </span>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}
